import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken.js";
import addLogDocument from "../addLogDocument.js";
import { auth } from "../../config/FirebaseConfig.js";
import { getUserById } from "../../models/UserFunctions.js";

const getFacadeUrl = async (carnetId, prefix) => {
  // Define the endpoint URL
  const token = await getOrRefreshFirebaseToken();
  const url = `${prefix}carnets/${carnetId}/facade`;

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const start = new Date();
    // Make the GET request
    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    const currentUser = auth.currentUser;

    if (!currentUser) {
      return "User not logged in";
    }

    const userData = await getUserById(currentUser.uid);
    const responseText = await response.text();
    const end = new Date();
    const elapsed = end - start;

    if (userData) {
      const orgId = userData.org_id;
      // Add log document
      await addLogDocument(
        url,
        prefix,
        currentUser.uid,
        orgId,
        response.status.toString(),
        "", // Additional optional fields
        carnetId,
        "",
        responseText,
        "GET",
        elapsed
      );
    }

    // Handle response
    if (response.ok) {
      return JSON.parse(responseText);
    } else {
      console.error(`Failed to get facade URL: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default getFacadeUrl;